import React from "react";
import SEO from "../../components/SEO";
import { useResponsiveValue } from "../../hooks/breakpoints";
/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import Page from "../../components/Page";
import { Container } from "../../components/core";
import { graphql } from "gatsby";

const DonLibre = ({ data }) => {
  const frontmatter = data.markdownRemark.frontmatter;
  const heightResponsive = useResponsiveValue(["2600px", "2700px", "2150px"]);

  return (
    <Page
      sx={{
        backgroundColor: "#f2f2f2",
      }}
    >
      <SEO title="Don libre" description={frontmatter.donLibre.text} />
      <Container
        variant="containerLg"
        as="section"
        sx={{
          paddingTop: [8, null, 8],
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: heightResponsive,
          }}
        >
          <iframe
            // onLoad={onLoad}
            id="myFrame"
            src="https://www.helloasso.com/associations/clean-my-calanques/formulaires/1/widget"
            width="100%"
            height="100%"
            frameBorder="0"
            style={{
              width: "100%",
              // height: "100%",
              overflow: "auto",
              top: 0,
            }}
          />
        </Box>
      </Container>
    </Page>
  );
};

export const query = graphql`
  query DonLibreQueryData {
    markdownRemark(fields: { slug: { eq: "/nous-aider/" } }) {
      frontmatter {
        donLibre {
          text
        }
      }
    }
  }
`;

export default DonLibre;
